import { GzDatePickerWebComponent } from './component/GzDatePickerWebComponent';

export { GzDatePickerWebComponent };
